import React, { useEffect, useMemo } from 'react'
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Paper, LinearProgress } from '@material-ui/core'

import { WebsiteBookingsOptions } from 'components'

const renderBooking = ({ id, from, to, departureDate, name, surname, price, routeName, createdDate }, index) => (
  <TableRow key={id}>
    <TableCell padding='none'>
      {index + 1}
    </TableCell>

    <TableCell padding='dense'>
      {createdDate.split(' ')[0]}
    </TableCell>

    <TableCell padding='dense'>
      {routeName}
    </TableCell>

    <TableCell padding='dense'>
      {departureDate}
    </TableCell>

    <TableCell padding='dense'>
      {from}
    </TableCell>

    <TableCell padding='dense'>
      {to}
    </TableCell>

    <TableCell padding='dense'>
      {name}
    </TableCell>

    <TableCell padding='dense'>
      {surname}
    </TableCell>

    <TableCell padding='dense'>
      {price}
    </TableCell>
  </TableRow>
)

const renderWebsiteBookings = (websiteBookings) => (
  <WebsiteBookingsOptions>
    <Table>
      <TableBody>
        {websiteBookings.map(renderBooking)}
      </TableBody>
    </Table>
  </WebsiteBookingsOptions>
)

export const WebsiteBookingsBase = ({
  classes, websiteBookings, subscribeWebsiteBookings, isLoading
}) => {
  useEffect(() => {
    subscribeWebsiteBookings()
  }, [subscribeWebsiteBookings])

  const isEmpty = useMemo(() => !isLoading && !websiteBookings.length, [isLoading, websiteBookings])

  return (
    <Grid
      container
      wrap='nowrap'
      spacing={32}
      className={classes.container}
      component={Paper}
    >
      <Grid xs item>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding='none'>
                {renderWebsiteBookings(websiteBookings)}
              </TableCell>

              <TableCell padding='dense'>
                Дата купівлі
              </TableCell>

              <TableCell padding='dense'>
                Маршрут
              </TableCell>

              <TableCell padding='dense'>
                Дата відправлення
              </TableCell>

              <TableCell padding='dense'>
                Звідки
              </TableCell>

              <TableCell padding='dense'>
                Куди
              </TableCell>

              <TableCell padding='dense'>
                Імя
              </TableCell>

              <TableCell padding='dense'>
                Прізвище
              </TableCell>

              <TableCell padding='dense'>
                Ціна
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isEmpty && (
              <TableRow>
                <TableCell
                  colSpan='9'
                  className={classes.emptyBookingsCell}
                >
                  Бронювання відсутні
                </TableCell>
              </TableRow>
            )}

            {isLoading && (
              <TableRow>
                <TableCell colSpan='9'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {!isLoading && websiteBookings.map(renderBooking)}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/WebsiteBookings/WebsiteBookings.js